import {Component, inject} from '@angular/core';
import {CardModule} from "primeng/card";
import {DatePipe} from "@angular/common";
import {TableLazyLoadEvent, TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {ProductService} from "@app/core/services";
import {BaseComponent} from "@app/core/bases";
import {Product} from "@app/core/interfaces";
import {ButtonModule} from "primeng/button";
import {TooltipModule} from "primeng/tooltip";
import {RouterLink} from "@angular/router";
import {takeUntil} from "rxjs";

interface Column {
    field: string;
    header: string;
}

@Component({
  selector: 'app-ebay-modified-product',
    imports: [
        CardModule,
        DatePipe,
        TableModule,
        TagModule,
        ButtonModule,
        TooltipModule,
        RouterLink
    ],
  templateUrl: './ebay-modified-product.html'
})
export class EbayModifiedProduct extends BaseComponent {
    productService: ProductService = inject(ProductService);
    products: Product[] = [];

    resultsLength = 0;
    pageIndex = 0;
    pageSize = 20;

    cols: Column[] = [
        { field: 'produit_id', header: 'ID Produit' },
        { field: 'marque', header: 'Marque' },
        { field: 'reference', header: 'Référence' },
        { field: 'modification_ebay_par', header: 'Modifié par' },
        { field: 'modification_ebay_le', header: "Modifié le" },
        { field: 'colonnes_modifies', header: "Modifications" },
    ];
    selectedColumns: Column[] = this.cols;

    isLoadingResults = true;
    isLoadedFromStorage = false;
    isSendingData: number[] = [];

    getTableEntries() {
        this.isLoadingResults = true;

        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.productService.getCollection({
            page: this.pageIndex + 1,
            size: this.pageSize,
            modification_ebay: true,
            fields: { produits: 'id,id_old,marque,reference,photo_couverture,modification_ebay_a_verifier,colonnes_modifies,modification_ebay_par,modification_ebay_le'}
        }).subscribe({
            next: (data) => {
                this.products = data.results;
                this.resultsLength = data.total;
            },
            error: (err) => {
                this.isLoadingResults = false;
                console.error(err);
            },
            complete: () => {
                this.isLoadingResults = false;
                this.apiCall$?.unsubscribe();
            }
        });
    }

    onLazyLoad(event: TableLazyLoadEvent) {
        this.pageIndex = event.first! / event.rows!;
        this.pageSize = event.rows!;
        this.getTableEntries();
    }

    onStateRestore(state: any) {
        // Called when dt table restores state from storage
        this.isLoadedFromStorage = true;
        try {
            if (state && state.first !== undefined && state.rows) {
                this.pageIndex = state.first / state.rows;
            }
        } catch (e) {
            // ignore, justepour évité des erreurs si le state n'est pas conforme
        }
    }

    onValidatingModification(product: Product) {
        this.isSendingData.push(product.id)

        this.productService.postValidateEbayModification(product.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    // console.log("synchronizeMarketplace response", response);
                    this.toastService.add({ severity: 'success', summary: 'Validation', detail: `Lecture des modifications validées.` })
                    this.isSendingData = this.isSendingData.filter(id => id !== product.id);
                    this.getTableEntries();
                },
                error: (error) => {
                    // console.error("synchronizeMarketplace error", error);
                    this.toastService.add({ severity: 'error', summary: 'Error', detail: `Echec de la validation.` })
                    this.isSendingData = this.isSendingData.filter(id => id !== product.id);
                }
            });
    }

    isSending(product: Product): boolean {
        return this.isSendingData.includes(product.id)
    }
}
